import React, { useState } from "react";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";

const ConfirmationModal = ({
  setShowModal,
  title = "Confirmation",
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm = () => {},
  onCancel = () => {},
}) => {
  // Button hover states
  const [isCancelButtonHovered, setIsCancelButtonHovered] = useState(false);
  const [isConfirmButtonHovered, setIsConfirmButtonHovered] = useState(false);

  // Methods
  const closeModal = () => {
    
    setShowModal(false);
  };

  const handleConfirm = () => {
    onConfirm();
    closeModal();
  };

  // Styles
  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    },
    modalContent: {
      backgroundColor: "white",
      padding: vh(20),
      borderRadius: vw(8),
      width: "90%",
      maxWidth: vw(500),
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
      position: "relative",
      zIndex: 10000,
      animation: "fadeIn 0.3s ease",
      fontFamily: "Karla, sans-serif",
    },
    closeBtn: {
      position: "absolute",
      top: vh(10),
      right: vw(15),
      fontSize: vh(24),
      fontWeight: "200",
      background: "none",
      border: "none",
      cursor: "pointer",
      color: "#666",
    },
    titleContainer: {
      marginBottom: vh(20),
    },
    title: {
      fontSize: vh(24),
      fontWeight: "700",
      marginBottom: vh(10),
    },
    message: {
      fontSize: vh(16),
      lineHeight: "1.5",
      color: "#444",
      marginBottom: vh(30),
    },
    buttonsContainer: {
      display: "flex",
      justifyContent: "flex-end",
      gap: vw(10),
    },
    cancelButton: {
      padding: `${vh(10)} ${vw(20)}`,
      color: "white",
      borderRadius: vw(5),
      backgroundColor: "#B39359",
      border: "none",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    cancelButtonHover: {
      backgroundColor: "#8E7343",
    },
    confirmButton: {
      padding: `${vh(10)} ${vw(20)}`,
      backgroundColor: "#192A3A",
      color: "white",
      borderRadius: vw(5),
      border: "none",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    confirmButtonHover: {
      backgroundColor: "#0F1A24",
    },
  };

  return (
    <div style={styles.overlay} onClick={closeModal}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button style={styles.closeBtn} onClick={closeModal}>
          ×
        </button>

        <div style={styles.titleContainer}>
          <h2 style={styles.title}>{title}</h2>
        </div>

        <div style={styles.message}>{message}</div>

        <div style={styles.buttonsContainer}>
          <button
            style={{
              ...styles.cancelButton,
              ...(isCancelButtonHovered ? styles.cancelButtonHover : {}),
            }}
            onClick={() => {
              onCancel();
              closeModal();
            }}
            onMouseEnter={() => setIsCancelButtonHovered(true)}
            onMouseLeave={() => setIsCancelButtonHovered(false)}
          >
            {cancelText}
          </button>

          <button
            style={{
              ...styles.confirmButton,
              ...(isConfirmButtonHovered ? styles.confirmButtonHover : {}),
            }}
            onClick={handleConfirm}
            onMouseEnter={() => setIsConfirmButtonHovered(true)}
            onMouseLeave={() => setIsConfirmButtonHovered(false)}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
